var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 22.1663H21.375V11.6409L13.5 5.28904L5.625 11.6409V22.1663H12.375V15.1663H14.625V22.1663ZM23.625 23.333C23.625 23.9773 23.1213 24.4996 22.5 24.4996H4.5C3.87868 24.4996 3.375 23.9773 3.375 23.333V11.0703C3.375 10.7103 3.53528 10.3704 3.80932 10.1494L12.8094 2.89012C13.2156 2.56245 13.7844 2.56245 14.1906 2.89012L23.1906 10.1494C23.4647 10.3704 23.625 10.7103 23.625 11.0703V23.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.83eafb5d575fb2c3a2e15c5da9b6f828.svg";
export { ForwardRef as ReactComponent };